import { useEffect } from "react";

/**
 * Lightweight document metadata helper for SEO + Open Graph tags.
 * Avoids react-helmet - we only have a handful of static legal pages so
 * direct DOM manipulation is simpler and dependency-free.
 */
export function usePageMeta({ title, description, ogImage }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · Fitnudge` : "Fitnudge";
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = selector.replace("meta[", "").replace("]", "").split("=");
        el.setAttribute(k, v.replace(/['"]/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:site_name"]', "content", "Fitnudge");
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    if (ogImage) {
      setMeta('meta[property="og:image"]', "content", ogImage);
      setMeta('meta[name="twitter:image"]', "content", ogImage);
    }
  }, [title, description, ogImage]);
}
